export default __webpack_public_path__ + "static/media/form-submit.e60c2ebd.png";